import { render } from "./ChildComponent.vue?vue&type=template&id=a9c07224&scoped=true"
import script from "./ChildComponent.vue?vue&type=script&lang=js"
export * from "./ChildComponent.vue?vue&type=script&lang=js"

import "./ChildComponent.vue?vue&type=style&index=0&id=a9c07224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c07224"]])

export default __exports__